<template>
  <v-container fluid class="pt">
    <v-layout row wrap>
      <v-card class="elevation-0 shadow-md white mt-2 flex xs12">
        <v-card-text class="pt-4">
          <v-layout row wrap class="align-center justify-center">
            <v-date
             :hideDetails="true"
              @input="getData"
              :clearable="false"
              format="YYYY-MM-DD"
              v-model="start_date"
              value-type="YYYY-MM-DD"
              class="flex xs12 md2 ma-1"
              input_id="net_date_expo"
              :placeholder="$t('from_date')"
            />
            <v-date
             :hideDetails="true"
              @input="getData"
              v-model="end_date"
              :clearable="false"
              format="YYYY-MM-DD"
              value-type="YYYY-MM-DD"
              class="flex xs12 md2 ma-1"
              :placeholder="$t('to_date')"
              input_id="net_end_date_expo"
            />
            <v-spacer />
            <v-flex xs12 md4 class="di-flex align-center">
              <v-text-field
                outline
                hide-details
                v-model="search"
                class="rounded"
                :placeholder="$t('search')"
                prepend-inner-icon="search"
              />
              <v-btn
                color="grey darken-2"
                class="mx-0"
                flat
                icon
                @click="printTable(false)"
              >
                <v-icon>print</v-icon>
              </v-btn>
              <v-btn
                color="grey darken-2"
                class="mx-0"
                flat
                icon
                @click="printTable(true)"
              >
                <v-icon>file_download</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <div class="di-flex flex align-center mb-3">
            <!-- <strong class="body-2 font-weight-bold">{{$t('daily_profits')}}</strong> -->
          </div>

          <v-data-table
            ref="tbl"
            item-key="id"
            :items="items"
            class="flex xs12"
            :loading="loading"
            :headers="headers"
            :total-items="meta.total"
            :pagination.sync="pagination"
            :rows-per-page-items="per_page"
          >
            <template slot="items" slot-scope="{ item, index }">
              <tr>
                <td>{{ index + 1 }}</td>
                <td>{{ item.date | persianDateFilter }}</td>
                <td>{{ item.commissions | currency }}</td>
                <td>{{ item.exchanges | currency }}</td>
                <td
                  class="font-weight-bold"
                  :class="{
                    'red--text': item.balance < 0,
                    'activeColor--text': item.balance > 0,
                  }"
                >
                  {{ item.balance | currency }}
                </td>
              </tr>
            </template>
            <template slot="footer">
              <td colspan="2">{{ $t("total") }}</td>
              <td class="body-2 font-weight-bold">{{ summery.commissions }}</td>
              <td class="body-2 font-weight-bold">{{ summery.exchanges }}</td>
              <td class="body-2 font-weight-bold">{{ summery.balance }}</td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import debounce from "@/plugins/vDebounce";
import curjs from "currency.js";

let currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 7);
export default {
  data() {
    return {
      items: [],
      search: "",
      selected: [],
      dialog: false,
      loading: false,
      end_date: new Date().toLocaleDateString("en-ca"),
      start_date: currentDate.toLocaleDateString("en-ca"),
      meta: {
        total: 0,
        perPage: 0,
        current_page: 0,
      },
      totalRows: 0,
      loading: true,
      editedIndex: -1,
      pagination: { page: 1, rowsPerPage: 50 },
    };
  },

  computed: {
    summery() {
      let commissions = 0,
        exchanges = 0,
        balance = 0;
      this.items.forEach((item) => {
        commissions = curjs(commissions).add(item.commissions);
        exchanges = curjs(exchanges).add(item.exchanges);
        balance = curjs(balance).add(item.balance);
      });
      console.log(exchanges);
      return {
        balance: balance,
        exchanges: exchanges,
        commissions: commissions,
      };
    },

    headers: (vm) => {
      return [
        {
          value: "index",
          width: "100px",
          sortable: false,
          text: vm.$t("number"),
        },
        {
          value: "date",
          sortable: false,
          text: vm.$t("date"),
        },
        {
          sortable: false,
          value: "commissions",
          text: vm.$t("commissions"),
        },
        {
          sortable: false,
          value: "exchanges",
          text: vm.$t("exchanges"),
        },
        {
          sortable: false,
          value: "balance",
          text: vm.$t("balance"),
        },
      ];
    },
  },
  methods: {
    getData() {
      this.loading = true;
      let { search } = this;
      const { page, rowsPerPage } = this.pagination;
      let params = {
        page,
        search,
        per_page: rowsPerPage,
        end_date: this.end_date,
        start_date: this.start_date,
      };
      this.axios
        .get(`daily-profits`, { params })
        .then((resp) => {
          this.items = resp.data.data;
          this.meta = resp.data.meta;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    printTable(excel) {
      let items = this.items;
      items.push({
        ...this.summery,
        date: this.$t("total"),
        class: "font-weight-bold",
      });
      let data = {
        items: items,
        headers: this.headers.slice(1),
        title: `Daily Incomes from ${this.persianDateFilter(
          this.start_date
        )} up to  ${this.persianDateFilter(this.end_date)}`,
        landscape: true,
      };

      if (excel) return this.xl_tables(data, "daily-profits",this.LONG_APP_NAME);
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    },
  },

  watch: {
    pagination: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    search: debounce(function (newVal) {
      this.getData(newVal);
    }, 1000),
  },
};
</script>
